import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'i2g-context-menu-spacer-item',
  templateUrl: './context-menu-spacer-item.component.html',
  styleUrls: ['./context-menu-spacer-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuSpacerItemComponent {}
